const KEY_TOKEN = "token";
import { AreaInfo, defaultCity } from '@/data/local/common'
import { stringify } from 'qs';

const KEY_CITY = "city";

/**
 * 获取uuid
 */
export const getUUID = (): string => {
    const s: any = [];
    const hexDigits = "0123456789abcdef";
    for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); 
    s[8] = s[13] = s[18] = s[23] = "-";

    const uuid = s.join("");
    return uuid;
}

/**
 * 是否有权限
 * @param key 
 */
export const isAuth = (key: string): boolean => {
  return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}

/**
 * 清除登录信息
 */
export const clearLoginInfo = (): void => {
  //Vue.cookie.delete('token')
  //store.commit('resetStore')
  //router.options.isAddDynamicMenuRoutes = false
}

export const getQueryParam = (route:any, key: string): string => {
  if (!route) {
    return getQueryString(key);
  }

  if (route.query[key]) {
    return route.query[key].toString();
  }

  return "";
}

export const getQueryString = (key: string): string => {
  let url_sub = window.location.hash.substr(window.location.hash.indexOf('?')+1)
  let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)", "i");
  let r = url_sub.match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return "";
}

export const getToken = (): string => {
  let token = localStorage.getItem(KEY_TOKEN);
  if (!token) {
    return "";
  }
  return token;
}

export const setToken = (token: string): void => {
  localStorage.setItem(KEY_TOKEN, token);
}

export const getCity = (): AreaInfo => {
  let city = localStorage.getItem(KEY_CITY);
  
  if (city) {
    return JSON.parse(city);
  }

  return defaultCity;
}

export const setCity = (city: AreaInfo): void => {
  localStorage.setItem(KEY_CITY, JSON.stringify(city));
}